import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { campaignsService, Campaign, UpdateCampaignRequest } from '@aslanpay/portal-common-lib';

interface UpdateCampaignMutation {
  campaignId: string;
  request: UpdateCampaignRequest;
}

const useUpdateCampaign = (
  options: UseMutationOptions<Campaign, Error, UpdateCampaignMutation>
) => {
  return useMutation<Campaign, Error, UpdateCampaignMutation>(
    ({ campaignId, request }) => campaignsService.updateCampaign(campaignId, request),
    options
  );
};

export default useUpdateCampaign;
